import * as React from 'react';
import { faCaretRight } from '@fortawesome/pro-solid-svg-icons/faCaretRight';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import styled from 'styled-components';
import Text from '@liveauctioneers/caterwaul-components/lib/Text/Text';

type Props = {
    external?: boolean;
    text?: any;
    url: string;
};

const SeeAllLink = ({ external = false, text = '', url = '' }) => {
    const externalProps = external
        ? {
              rel: 'noopener',
              target: '_blank',
          }
        : {};

    return (
        <StyledSeeAllLink {...externalProps} route={!external} to={url || '#'}>
            <Text>{text || <FormattedMessage id="see_all" />}</Text>
            <StyledIcon icon={faCaretRight} />
        </StyledSeeAllLink>
    );
};

export default React.memo<Props>(SeeAllLink);

const StyledSeeAllLink = styled(Link)`
    &&&& {
        display: flex;
        flex-direction: row;
        align-items: center;
        text-decoration: none;

        & > span {
            font-family: ${({ theme }) => theme.typography.fontPrimaryStrong};
            color: ${({ theme }) => theme.colors.steel};
            font-size: 14px;
            letter-spacing: 0.5px;
            line-height: 20px;
        }

        &:hover {
            svg,
            span {
                color: ${({ theme }) => theme.colors.blue200};
            }

            text-decoration: underline;
        }

        @media (max-width: 550px) {
            margin-left: 10px;
        }
    }
`;

const StyledIcon = styled(FontAwesomeIcon)`
    color: ${({ theme }) => theme.colors.steel};
    height: 14px;
    line-height: 20px;
    margin-left: 4px;
    padding-top: 1px;
`;
